import { useGetGroupsQuery } from '@entities/clients/rtk-query.ts';
import { useGroups } from '@entities/common/groups';
import { useEffect, useState } from 'react';

export const useLoadGroups = (withoutPagination?: boolean) => {
  const [status, setStatus] = useState('idle');
  const [page, setPage] = useState(1);
  const [list, setList] = useState<number[]>([]);
  const { groups, addGroups } = useGroups();
  const [titles, setTitles] = useState<string[]>([]);
  const { data, isLoading, isFetching } = useGetGroupsQuery({
    page,
    pagination: withoutPagination ? false : undefined,
  });

  useEffect(() => {
    if (data) {
      const titles = data.results.map((group) => group.name);
      const ids = data.results.map((group) => group.id);
      setTitles(titles);
      setList(ids);
      addGroups(data.results);
    }
  }, [data]);

  useEffect(() => {
    setStatus(isLoading || isFetching ? 'loading' : 'idle');
  }, [isLoading, isFetching, setStatus]);

  return {
    titles,
    ids: list,
    groups,
    hasMore: Boolean(data?.next),
    loadGroups: () => setPage((p) => p + 1),
    status,
  };
};
